import React from "react";

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`py-20 md:py-28 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 lg:px-10">{children}</div>
  </section>
);

export const Eyebrow = ({ children }) => (
  <span className="sep-lotus mb-6">{children}</span>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-serif text-4xl md:text-5xl leading-[1.1] text-[#3d2817] ${className}`}>
    {children}
  </h2>
);

export const Lead = ({ children, className = "" }) => (
  <p className={`text-lg text-[#5a4a3a] leading-relaxed max-w-2xl ${className}`}>{children}</p>
);

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="relative bg-[#f6efe0] border-b border-[#e9dcc0]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-28 rise">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] text-[#3d2817] max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-6 text-lg text-[#5a4a3a] max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
